// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__HNKbr","approved":"Status_approved__usIb8","rejected":"Status_rejected__2nBnl","expired":"Status_expired__2KEo-","label":"Status_label__3MeaK"};